export const listMutations = <const>{
	TABULKOVA_POZICE_SELECT_MAPPER: 'tabulkovaPoziceSelectMapper',
};

export const editMutations = <const>{
	TABULKOVA_POZICE_SELECT_MAPPER: 'tabulkovaPoziceSelectMapper',
	SET_TABULKOVA_POZICE: 'setTabulkovaPozice',
};

export const editActions = <const>{
	FETCH_TABULKOVA_POZICE: 'fetchTabulkovaPozice',
};
